var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product
    ? _c("div", [
        _c("div", { staticClass: "product-bubble-wrapper" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBubble,
                  expression: "showBubble"
                }
              ],
              staticClass: "product-bubble shipping-packing-item-bubble"
            },
            [_vm._v("倉庫に納品済の商品も梱包設定が変更されます。")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.product.packingSettingKbn,
                  expression: "product.packingSettingKbn"
                }
              ],
              staticClass: "form-control",
              attrs: {
                name: "packing-setting-kbn",
                id: "packing-setting-kbn-" + _vm.product.asin
              },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.product,
                      "packingSettingKbn",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  function($event) {
                    _vm.update()
                  }
                ]
              }
            },
            _vm._l(_vm.arrPackingSettingKbn, function(arrItem, arrIndex) {
              return _c(
                "option",
                { key: arrIndex, domProps: { value: arrItem.id } },
                [_vm._v(_vm._s(arrItem.name))]
              )
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aafc2bb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aafc2bb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/components/ShippingPackingItem.vue
// module id = null
// module chunks = 